<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container body-background">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-12 d-flex flex-column">
              <div class="mt-5 card card-plain custom-background">
                <div class="logo-container">
                  <img
                    src="@/assets/PMW-40.png"
                    alt="Logo"
                    class="logo-image"
                  />
                </div>
                <!-- <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder text-success text-gradient">
                    Bienvenido de nuevo
                  </h3>
                  <p class="mb-0">Ingrese su correo electrónico y contraseña para iniciar sesión</p>
                </div> -->
                <div class="card-body">
                  <form role="form" class="text-start" @submit.prevent="frmLogin">
                    <label>Correo electrónico</label>
                    <soft-input
                      id="email"
                      type="email"
                      placeholder="Correo electrónico"
                      name="email"
                      :value="email"
                      v-model:email="email"
                    />
                    <label>Contraseña</label>
                    <soft-input
                      id="password"
                      type="password"
                      placeholder="Contraseña"
                      name="password"
                      :value="password"
                      v-model:password="password"
                    />
                    <div class="text-center">
                      <soft-button
                        type="submit"
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        >Iniciar sesión
                      </soft-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SoftInput from '@/components/SoftInput.vue'
import SoftButton from '@/components/SoftButton.vue'
import { mapMutations } from 'vuex'
import LoginService from '@/services/Login'
import axios from '@/utils/axios'
const body = document.getElementsByTagName('body')[0]

export default {
  name: 'SignIn',
  components: {
    SoftInput,
    SoftButton
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  created () {
    this.toggleEveryDisplay()
    this.toggleHideConfig()
    body.classList.remove('bg-gray-100')
  },
  beforeUnmount () {
    this.toggleEveryDisplay()
    this.toggleHideConfig()
    body.classList.add('bg-gray-100')
  },
  methods: {
    ...mapMutations(['toggleEveryDisplay', 'toggleHideConfig']),
    async frmLogin () {
      try {
        const loginService = new LoginService(axios)
        loginService.setCorreoElectronico(this.email.trim())
        loginService.setContrasena(this.password.trim())
        const response = await loginService.login()
        console.log(response)
        response.login = true
        console.log(response.token)
        localStorage.setItem('refreshToken', response.refreshToken)
        localStorage.setItem('login', response.login)
        localStorage.setItem('token', response.token)
        // console.log('response', response)
        // Realizar la redirección a la página principal después de iniciar sesión
        this.$router.push('/')
      } catch (error) {
        console.log('error:', error)
      }
    }
  }
}
</script>
<style scoped>
.custom-background {
  background: url("@/assets/intro-36.png") no-repeat center center fixed;
  background-size: cover;
}
.body-background {
  background: url("@/assets/PMW-41.png") no-repeat center center fixed;
  background-size: cover;
}
/* .login-container {
  background-image: url("@/assets/intro-36.png");
  background-size: cover;
  background-position: center;
  height: 100vh;
} */
.login-card, .card-header {
  background-color: transparent;
  padding: 24px;
}
.logo-image {
  max-width: 100%;
  height: auto;
}
</style>
